import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper feature15',
      playScale: 0.3,
      always: false,
    },
    page: {
      className: 'home-page feature15-page',
    },
    bg: {
      className: 'bg',
      children: 'https://imm.86links.com/assets/landing/feature/%E8%83%8C%E6%99%AF4.png',
    },
    title: {
      className: 'feature15-title',
      children: [
        {
          name: 'title0',
          className: 'feature15-title-item',
          children: '汽车主导产业',
        },
      ],
    },
    content: {
      className: 'feature15-content',
      left: {
        className: 'feature15-content-left',
        imgs: {
          className: 'feature15-content-left-imgs',
          children: [
            {
              name: 'box0',
              className: 'feature15-content-left-img',
              children: 'https://imm.86links.com/assets/landing/images/%E7%9F%A9%E5%BD%A2%402x(2).png',
            },
            {
              name: 'box1',
              className: 'feature15-content-left-img',
              children: 'https://imm.86links.com/assets/landing/images/%E4%BD%8D%E5%9B%BE%402x(3).png',
            },
            {
              name: 'box2',
              className: 'feature15-content-left-img',
              children: 'https://imm.86links.com/assets/landing/images/%E7%9F%A9%E5%BD%A2%E5%A4%87%E4%BB%BD%203%402x(2).png',
            },
          ],
        },
        title: {
          className: 'feature15-content-left-title',
          children: [
            {
              name: 'titleL0',
              className: 'feature15-content-left-title-item',
              children: '基本形成集整车制造、新能源汽车制造、氢能产业、零部件生产、研发设计、贸易博览文化于一体的汽车全产业链格局。<br/><br/>初步形成涵盖全系车型和全链协同发展的汽车产业生态圈，是全国第六大汽车产业基地。',
            },
          ],
        },
        box: {
          className: 'feature15-content-left-box',
          img: {
            className: 'feature15-content-left-box-img',
            children: 'https://imm.86links.com/assets/landing/images/crad%402x.png',
          },
          left: {
            className: 'feature15-content-left-box-left',
            children: [
              {
                name: 'boxLeft0',
                className: 'feature15-content-left-box-title1',
                children: '2020年汽车产量',
              },
              {
                name: 'boxLeft1',
                className: 'feature15-content-left-box-title2',
                children: '104.5万辆',
              },
              {
                name: 'boxLeft2',
                className: 'feature15-content-left-box-title3',
                children: '占全省90% 占全市95%',
              },
            ],
          },
          right: {
            className: 'feature15-content-left-box-right',
            children: [
              {
                name: 'boxRight0',
                className: 'feature15-content-left-box-title1',
                children: '汽车制造业实现产值',
              },
              {
                name: 'boxRight1',
                className: 'feature15-content-left-box-title2',
                children: '1507.5亿元',
              },
            ],
          },
        },
      },
      right: {
        className: 'feature15-content-right',
        children: 'https://imm.86links.com/assets/landing/images/%E7%94%BB%E6%9D%BF%402x(8).png',
      },

    },
  },
};
